var process=require("__browserify_process");
var app = require('./index'),
	getSongFormOptions = require('../song-form-options'),
	Paginator = require('derby-ui-paginator/Paginator'),
	Song = require('../data-objects/Song'),
	Subscription = require('../data-objects/Subscription'),
	MongoQuery = require('../MongoQuery'),
	deepCopy = require('../util/deepCopy'),
	RangeSelector = require('../../ui/voiceRangeSelector/RangeSelector');

//define reactive functions
require('../reactive-fns')(app);

log = function(msg) { console.log(msg); }

//TEMP
//voice range demo
app.get('/range-demo', function(page, model, params, next) {
    model.set('_page.hideSidebar', true);
	page.render('range-demo');
});

// Derby routes can be rendered on either the client or the server

//Set variables that should be available to all templates
app.get('*', function(page, model, params, next) {
	if (! require('derby').util.isServer) {
		//force server-side rendering for IE, since Derby's client-side rendering sometimes doesn't work in IE
		//TODO test IE 11 and other future versions; this might not be necessary for them
		if (navigator.appName.indexOf("Internet Explorer")!=-1) {
			window.location = params.url;
		}
		//If rendering on the browser, track the page change in Google Analytics
        //(otherwise it wouldn't get picked up since Derby uses pushState for client-side rendering)
        if (window.ga) {
            ga('send', 'pageview', params.url);
        }
        else if (window.console && console.error) {
            console.error('Error sending pageview event: Google Analytics not loaded');
        }
	}

    model.set('_global.currentYear', new Date().getFullYear());
    if (!model.get('_session.user')) {
        model.set('_session.user', {firstName: 'Guest'});
	}
	
	//Jan 08 2017
	var adExpTime = 1515387600000
	model.set('_page.showNatsAd', Date.now() < adExpTime)
	
	//preload featured composers of the month
	if (!model.get('_global.featuredComposers')) {
		model.fetch('config.featuredComposers', function(err) {
			if (err) return next(err);
			model.set('_global.featuredComposers', model.get('config.featuredComposers'));
			next();
		});
		/*
		model.fetch('config.featuredComposers', 'config.chicagoCompetitionComposers', function(err) {
			if (err) return next(err);
			model.set('_global.featuredComposers', model.get('config.featuredComposers'));
			model.set('_global.chicagoCompetitionComposers', model.get('config.chicagoCompetitionComposers'));
			next();
		});
		*/
	}
	else next();
});

//Homepage
app.get('/', showHomepage);
function showHomepage(page, model, params, next) {
	model.set('_page.isHomepage', true);

	// TEMP
	model.set('_page.isNewHomepage', Boolean(params.query.newHomepage))
	
	var SearchSongsUseCase = require('../use-cases/SearchSongs');
	var searchSongsUseCase = new SearchSongsUseCase(model);

	//Set options for search form
	var options = getSongFormOptions();
	for (var key in options) {
		model.set('_options.'+key, options[key]);
	}

	var searchModel = model.at('_session.songSearch');
	var search = searchModel.get();

	if (search) {
		model.set('_page.isNewSearch', false);

		//if any of the song details parameters are filled in, expand that section when the page loads
		//(we check to see if the previous search parameters contain any other parameters besides the tier 1 parameters,
		//meaning that something in the song details section was filled in)
		var tier1Params = ['ageRange', 'ageRanges', 'voiceType', 'voiceTypes', 'tempo', 'tempos', 'isComic'];
		if (!model.get('_session.user.isSubscribed')) {
			tier1Params.push('composerIds');
		}

		//Determine whether or not the song details panel should initially be expanded
		var showSongDetails = model.get('_session.songSearch._showSongDetailsOnPageLoad');

		//Did the previous search include song detail parameters?
		var hasSongDetailsParams = false;
		delete search.decadeOrYear; //this is preselected so it doesn't count
		delete search._showSongDetailsOnPageLoad; //this isn't a real search parameter so again, doesn't count
		for (var key in search) {
			//special case: don't allow the fact that majorMinor is set to null by default to be mistaken for
			//a user-entered search parameter
			if (key=='originalKey' && !search.originalKey.pitch && !search.originalKey.majorMinor) {
				continue;
			}
			if (tier1Params.indexOf(key) == -1) {
				hasSongDetailsParams = true;
				break;
			}
		}
		//If the previous search included song detail parameters, always show the song details panel so the user
		//can see his/her previous exntries
		if (hasSongDetailsParams) showSongDetails = true;

		model.set('_session.songSearch._showSongDetailsOnPageLoad', showSongDetails);

		//Prefill search form with previous entries
		//Many are prefilled automatically - these have to be done manually

		//Check to see if any parameters had "multiple" selected
		var fieldsWithMultipleOption = ['ageRange', 'voiceType', 'tempo', 'popularity'];

		fieldsWithMultipleOption.forEach(function(fieldName) {
	        var fieldNamePlural = (fieldName === 'popularity' ? 'popularities': fieldName + 's');
	        if (search[fieldNamePlural]) {
	            if (search[fieldNamePlural].length > 1) {
	                model.set('_page.' + fieldNamePlural, search[fieldNamePlural]);
	                search[fieldName] = 'multiple';
	            }
	            else search[fieldName] = search[fieldNamePlural][0];
	        }
		});

		if (search.timeSignature) {
			var timeSignature = search.timeSignature;
			var timeSignatureNums = timeSignature.split('/');
			searchModel.set('timeSignatureNumerator', parseInt(timeSignatureNums[0]));
			searchModel.set('timeSignatureDenominator', parseInt(timeSignatureNums[1]));
		}

		//selects "both" for comedic/dramatic since this is a modification of a previous search
		if (!('isComic' in search)) model.set('_page.comicDramaticNotSpecified', true);

		//preselect the appropriate option (decade or year)
		if (search.fromYear || search.toYear) {
			searchModel.set('decadeOrYear', 'year');
		}
		else searchModel.set('decadeOrYear', 'decade');

		if (search.voiceRange) {
			model.set('_page.limitVoiceRange', true);
		}
		//restore previous voice range search even if it was disabled on the last search
		// - but this doesn't become active unless the user clicks "Enable voice range search" again
		else {
			var prevVoiceRange;
			if (prevVoiceRange = model.get('_session.prevVoiceRangeSearch'))
				model.set('_session.songSearch.voiceRange', prevVoiceRange);
		}
	}
	else {
		model.set('_page.isNewSearch', true);

		//set defaults
		model.set('_session.songSearch', {
			decadeOrYear: 'decade',
			timeSignatureDenominator: 4
		});
	}
	
	searchSongsUseCase.getFeaturedComposers(function(err, featuredComposers) {
		if (err) return next(err);
		//setFeaturedComposerBios(model);
		
		model.set('_page.featuredComposers', featuredComposers);
		page.render('home');
	});
	
	//var featuredComposers = model.query('composers', {'id': {'$in': searchSongsUseCase.getFeaturedComposerIds()}, $orderby: {lastName:1}});
	//model.fetch(featuredComposers, function(err) {
	//	if (err) return next(err);
	//	var composers = featuredComposers.get();
	//	
	//	//special case: list lyricsist also
	//	composers.forEach(function(composer) {
	//		if (composer.id == '9baf04c5-4a98-4f58-b8ea-1dd6d0f69483') {
	//			composer.firstName = 'Nick Hedger /';
	//			composer.lastName = 'Ben Nicholson';
	//		}
	//		//another special case: show middle initial
	//		else if (composer.id == 'ceae069d-0887-45f8-8315-6c851e5dfbf2') {
	//			composer.firstName = 'Michael R.';
	//		}
	//	});
	//	
	//	model.set('_page.featuredComposers', composers);
	//	
	//	//setFeaturedComposerBios(model);
	//	page.render('home');
	//});
}

//For institutional accounts ("i" stands for "institution").
//Currently we're just rendering the homepage.
//In the future we may want to make the system more efficient by doing the IP recognition check here
//rather than on every page for every user.
app.get('/i/:institutionDomainName', function(page, model, params, next) {
	showHomepage(page, model, params, next);
});

//Special Event: Chicago Competition 2016
/*
app.get('/chicago-prize', function(page, model, params, next) {
	model.set('_page.isChicagoPrizeHomepage', true);
	showHomepage(page, model, params, next);
});

app.get('/chicago-prize/listings', function(page, model, params, next) {
	var query = model.query('composers', {
		id: {$in: model.get('_global.chicagoCompetitionComposers') },
		$orderby: {lastName:1, firstName:1}
	});
	query.fetchGet().then(function(composers) {
		model.set('_page.composers', composers);
		page.render('chicago-prize-composers');
	})
	.catch(function(err) {
		return next(err);
	})
});
*/

/*
function setFeaturedComposerBios(model) {
	var bios = {
		'Teresa Lotz': 'Teresa Lotz is a playwright, composer and lyricist/book-writer whose work includes <em><a href="http://www.teresalotz.com/shecallsmefirefly.html">She Calls Me Firefly</a> (VH Theatrical Development Foundation and New Perspectives Theatre Company)</em>, <em><a href="http://www.teresalotz.com/awakening.html">The Awakening</a></em> (music) with book-writer/lyricist <a href="http://sarahrebell.com/sarahrebell.com/home.html" target="_blank">Sarah Rebell</a> <em><a href="http://www.teresalotz.com/threetimesfast.html">Three Times Fast</a></em> (book and music) with book-writer/lyricist <a href="http://www.naomimatlow.com/" target="_blank">Naomi Matlow</a> , <em><a href="http://www.teresalotz.com/thebowl.html">The Bowl</a></em>,&nbsp; <em><a href="http://www.teresalotz.com/petuniafang.html">Petunia and Fang</a>&nbsp;</em> with composer Kiyun Kim.Her work has been heard at the New York Musical Theatre Festival, 54 Below, Dixon Place, Metropolitan Room and the Duplex'
	  , 'Zoe Sarnak': 'ZOE SARNAK is an award winning composer, lyricist and playwright.  Sarnak wrote the book, music and lyrics for Mixtape, featured in Silent Street Productions 2012 season, A Lasting Impression, winner of Pace New Musicals 2012, Off-Broadway at the 4th Street Theatre at NYTW in August 2012, and The Years Between workshopped in Musical Theatre Factory’s 2014 summer season.'
	  , 'Brett Macias': 'Brett Macias has composed music for Webster University, Encores! (NYC), and the St. Louis Repertory Theatre. MFA: NYU Musical Theatre Writing. Musicals include: FISHING THE MOON, THE LAVATORY, BENEATH THE SURFACE, and BEAUTIFUL DREAMER. He was featured in American Theater Magazine in 2009 as a writing team to watch. GUMBO was selected by the Grand Jury for the 2014 New York Musical Festival Next Link Festival. <a href="http://brettmacias.com" target="_blank">brettmacias.com</a>'
	  , 'Frank Ceruzzi': 'An English teacher at Horace Greeley High School in Chappaqua, New York, who specializes in teaching creative writing and drama. He received an MA from Georgetown University, where he wrote extensively on pop culture appropriations of Shakespeare. Frank was thrilled to write WikiMusical with his former student, Blake J. Harris! Frank is a proud member of the Dramatists Guild of America.'
	  , 'John McMahon': "John McMahon is the composer of many cabaret and novelty songs in addition to the full length musicals SATAN'S SCHOOL FOR GIRLS, FRIENDS LIKE THESE, which won the Most Promising Musical award in the TRU musical reading series, LOVE AND OTHER FABLES, which received a public reading at Chicago’s Windy City Playhouse in April 2015 and a reading in October 2015 as part of the Penn State NU. Musicals series."
	  
	//	'Danny Abosch': 'Danny Abosch is a composer/lyricist whose musicals include Fancy Nancy The Musical (Off-Broadway 2012-2014, National Tour 2013-2015, Cast Recording available on Ghostlight Records), Placebo (winner of the 2012 PMTP Development Award) ,Off The Wall (First Prize winner of NMI’s 2014 Search for New Musicals), and Miles & Me (2014 workshop at the Musical Theatre Factory in NYC).'
	//  , 'Natalie Lovejoy': 'Natalie\'s work is currently listed on <a href="http://www.contemporarymusicaltheatre.com/content/natalie-lovejoy" target="_blank">contemporarymusicaltheatre.com</a>. She\'s a graduate of NYU, BMI and am the writer of the Off-Off Broadway musical <a href="http://www.deployedthemusical.nyc/" target="_blank"><i>Deployed</i></a>'
	//  , 'Nick Luckenbaugh': 'Nick Luckenbaugh is an award-winning NYC songwriter whose work has been performed at 54 Below, Atlantic Theater Company, Sidewalk Cafe, The Path Cafe, The Underground Lounge, and The Cellar at The West End among other venues. His song and dance cycle "Royal Fables" recently premiered in November 2014 in NYC. Other in-development musicals include "Unbound" (an original fantasy written with singer-songwriter Amy Molewski) and the new book musical "Aurora."'
	//  , 'Zoe Sarnak': "Zoe Sarnak is an award winning composer, lyricist and playwright. Sarnak’s The Quad was produced at Harvard’s Loeb Experimental Theatre. Sarnak wrote the book, music and lyrics for Mixtape, featured in Silent Street Productions 2012 season, A Lasting Impression, winner of Pace New Musicals 2012, Off-Broadway at the 4th Street Theatre at NYTW in August 2012, winner of the 2013 NJ Playwright's contest, and produced in concert by Cutting Edge Composers at Joe's Pub in 2013, and The Years Between workshopped in Musical Theatre Factory’s 2014 summer season."
	//  , 'Jim Territo': 'Since graduating from the University of Michigan in 2001, Jim has worked as an educator  composer, music director, and freelance rock pianist. He has published several works for band, and an original musical, "Justice in Dusty Junction".'
	//  , 'Sam Carner and Derek Gregor': 'Sam Carner and Derek Gregor are one of Playbill.com’s twelve “Contemporary Musical Theatre Songwriters You Should Know”. Their musical UNLOCK’D won a Richard Rodgers Award and “Best of the Fest” at the New York Musical Theatre Festival. Their musical ISLAND SONG has had workshops and concerts around the US, as well as in London, Paris, and Tokyo. 5 of its songs have been nominated for MAC Awards.'
	};
	model.set('_page.featuredComposerBios', bios);
	
	var composerNames = [];
	var i = 0;
	for (var name in bios) {
		composerNames.push({
			name: name,
			index: i
		});
		i++;
	}
	model.set('_page.featuredComposerNames', composerNames);
}
*/

//IMPORTANT NOTE:
//This currently only works correctly when rendering on the server if decade or year is one of the search conditions,
//because apparently the date conditions don't get correctly reconstructed as real date objects when the query JSON is
//parsed by the server. So for now we have forced server rendering from the songs.search controller method
app.get('/search/songs', function(page, model, params, next) {
	//polyfills for the Date object
    require('date-utils');

	//TODO
	//Figure out how to do decade/year search from client (see note above)
	//For now we always render on the server
	if (!require('derby').util.isServer) {
		window.location = params.url;
		return;
	}
	
	model.set('_page.isFirefox', page._res.req.headers['user-agent'].indexOf('Firefox') != -1);
	
	//Get search parameters from request
	var search;
	if (params.query.search) {
		try {
			search = JSON.parse(params.query.search);
		}
		catch (e) { //JSON parsing error
			page.redirect('/'); //redirect to homepage
			return;
		}
		
		if (params.query.chicagoPrize) {
			model.set('_page.isChicagoPrizeSearch', true);
		}
		
		//note that _session model properties (or properties on any collection starting with an underscore)
		//are only stored client-side; see controller and render-fns for where the search parameters actually
		//get sent to the server via Ajax to be saved in Express's session
		model.set('_session.songSearch', deepCopy(search));
		
		//delete the prevVoiceRange property if it exists; this is only used to remember the voice range
		//if voice range search is currently disabled, and it was already saved to the session thanks to
		//the /save-song-search-to-session route on the server
		delete search.prevVoiceRange;
	}
	else {
		//if no search parameters in the URL, then look in the session
		search = model.get('_session.songSearch');
		if (search) { //redirect so that the search parameters are in the URL
			page.redirect('/search/songs?search=' + encodeURIComponent(JSON.stringify(search)));
		}
		else {
			page.redirect('/'); //redirect to homepage
		}
		return;
	}
	
	model.set('_page.search', search);
	searchSongs_queryAndRenderSearchResults(page, model, params, next, search);
});

function searchSongs_queryAndRenderSearchResults(page, model, params, next, search) {
	var userIsSubscriber = model.get('_session.user.isSubscribed');
	
	var SearchSongsUseCase = require('../use-cases/SearchSongs');
	var searchSongsUseCase = new SearchSongsUseCase(model, search);

	if (params.query.sort) searchSongsUseCase.setSortOrder(params.query.sort);

	if (!userIsSubscriber) {
		//Determine whether the search contains anything other than one of the composer checkboxes
		//If the user *only* selected composer(s) and nothing else, then there's no point in showing the
		//notice with the number of results that would be returned if the user were a subscriber
		//and all composers were included.
		var searchOnlyContainsComposer = (Object.keys(search).length==1 && search.composerIds);
		model.set('_page.showNumSongsSearchingAllComposers', !searchOnlyContainsComposer);
	}

	//Build database query

	if (model.get('_page.showNumSongsSearchingAllComposers')) {
		var countQuery = model.query('songs', searchSongsUseCase.buildCountQueryWithoutComposerFilter());
		model.fetch(countQuery, function(err) {
			if (err) return next(err);

			var numSongs = countQuery.get().extra;
			if (numSongs > 0) {
                model.set('_page.numSongsSearchingAllComposers', numSongs);
            }
            //no point in advertising the number of results if it's zero
            else model.set('_page.showNumSongsSearchingAllComposers', false);
		});
	}
	
	var query = searchSongsUseCase.buildSearchQuery();
	//This is used when saving dynamic song lists
	model.set('_page.queryParams', query);
	
	//log('query:'); console.dir(query);
	
	//Get paginated query
	var paginator = new Paginator(model, 'songs', params, query, '_session.songs.paginator');
	
	model.set('_page.currentBaseUrl', getCurrentPageBaseUrl(params.url));
	
	var songQuery = paginator.getQueryForCurrentPage();
	model.ref('_page.paginator', '_session.songs.paginator');

	//Used to display search conditions at top of page
	var composersQuery, lyricistsQuery;
	if (search.composerIds) {
		if (typeof search.composerIds == 'string') search.composerIds = search.composerIds.split('|');
		composersQuery = model.query('composers', {id: {$in: search.composerIds}});
	}

	if (search.lyricistIds) {
		if (typeof search.lyricistIds == 'string') search.lyricistIds = search.lyricistIds.split('|');
		lyricistsQuery = model.query('lyricists', {id: {$in: search.lyricistIds}});
	}

	//Workaround to pass multiple queries conditionally to model.fetch(), since
	//we won't always need to query composers and lyricists and model.fetch(query1, undefined, undefined) doesn't work
	var args = [songQuery];
	if (composersQuery) args.push(composersQuery);
	if (lyricistsQuery) args.push(lyricistsQuery);
	args.push(fetchCallback);
	model.fetch.apply(model, args);

	function fetchCallback(err) {
		if (err) return next(err);
		//log('# RESULTS:' + songQuery.get().length)

		songQuery.ref('_page.songsRaw'); //raw data from DB
		model.start(
			'prepareSongResults', //reactive function (defined in reactive-fns.js)
			'_page.songs', //output path
			'_page.songsRaw' //input path
		);

		var composersAndLyricists = {};
		if (composersQuery)
			composersAndLyricists.composers = composersQuery.get();
		if (lyricistsQuery)
			composersAndLyricists.lyricists = lyricistsQuery.get();
			
		//Search parameters as an array so we can display them at the top of the page
		var arrSearchParams = [];
		for (var field in search) {
			arrSearchParams.push({
				field: field,
				val: search[field]
			});
		}
		var firstFew = arrSearchParams.slice(0, 4);
		var remaining = arrSearchParams.slice(4);

		var labelMap = {
			ageRanges: 'Age Range'
		  , voiceTypes: 'Voice Type'
		  , tempos: 'Tempo'
		  , isComic: 'Comedic/Dramatic'
		  , composerIds: 'Composer'
		  , lyricistIds: 'Lyricists'
		  , hasFemaleComposer: 'Woman/Nonbinary Composer'
		  , hasBIPOCComposer: 'Global Majority Composer'
		  , hasFemaleLyricist: 'Woman/Nonbinary Lyricist'
		  , hasBIPOCLyricist: 'Global Majority Lyricist'
		  , songTitle: 'Song Title'
		  , showTitle: 'Show Title'
		  , fromYear: 'Year'
		  , fromDecade: 'Decade'
		  , toYear: 'Year'
		  , toDecade: 'Decade'
		  , timeSignature: 'Time Signature'
		  , voiceRange: 'Voice Range'
		  , accompanistDifficulty: 'Accompanist Difficulty'
		  , originalKey: 'Original Key'
		  , tags: 'Keywords/Tags'
		  , popularities: 'Popularity'
		  , isRecommended: "Founder's Pick"
		};
		var booleanFields = ['isComic'];
		
		var popularityLabels = getSongFormOptions().popularityLabels;
		
		var searchParamStrs = {};
		var glue = '';
		for (var i = 0, len = arrSearchParams.length; i < len; i++) {
			var condition = arrSearchParams[i];
			var field = condition.field;
			var val = condition.val;

			if (field != 'isComic'  //exception for boolean fields
			  && !val)
				continue;

			var label = '';
			if (field in labelMap) {
				fieldName = labelMap[field];
				label = '<dt>'+fieldName+'</dt> ';
			}
			else if (field != 'toYear' && field != 'toDecade') //special case
				continue;

			var strVal = '';
			switch (field) {
				case 'isComic':
					strVal = (val ? 'Comedic': 'Dramatic');
					break;

				case 'composerIds':
				case 'lyricistIds':
					var composersOrLyricists = composersAndLyricists[ (field=='composerIds' ? 'composers': 'lyricists') ];
					var composerNames = [];
					composersOrLyricists.forEach(function(composerOrLyricist) {
						composerNames.push(composerOrLyricist.lastName + ', ' + composerOrLyricist.firstName);
					});
					strVal = composerNames.join('; ')
					break;

				case 'hasFemaleComposer':
				case 'hasBIPOCComposer':
				case 'hasFemaleLyricist':
				case 'hasBIPOCLyricist':
					strVal = 'Yes';
					break;

				case 'fromYear':
				case 'fromDecade':
					strVal = val;
					var yearOrDecade = (field=='fromYear' ? 'Year': 'Decade');
					var to = search['to'+yearOrDecade];

					if (to != val) {
						if (to) strVal += '-' + to;
						else strVal += ' or later';
					}
					searchParamStrs.year = label + '<dd>' + strVal + '</dd>';
					continue;

				case 'toYear':
				case 'toDecade':
					strVal = val;
					var yearOrDecade = (field=='toYear' ? 'Year': 'Decade');
					var from = search['from'+yearOrDecade];
					if (from != val) {
						if (from) {
							//already taken care of by above condition, we don't need to do anything else
                        	continue;
						}
						else strVal += ' or earlier';
					}
					searchParamStrs.year = label + strVal;
					continue;

				case 'voiceRange':
					var range = val;
					if (!range.lowestNote && !range.highestNote) continue;

					strVal = RangeSelector.getRangeDisplayString(range.lowestNote, range.highestNote)
					/*
					strVal = '';
					var voiceRange = val;
					if (!voiceRange.lowestNote && !voiceRange.highestNote) continue;

					if (voiceRange.lowestNote) {
						strVal = voiceRange.lowestNote.note + voiceRange.lowestNote.octave;
						if (voiceRange.highestNote) strVal += ' to ';
						else {
							strVal = 'lowest note = ' + strVal;
							if (!voiceRange.lowestNote.exactMatch) strVal+= ' or higher';
						}
					}
					if (voiceRange.highestNote) {
						strVal += voiceRange.highestNote.note + voiceRange.highestNote.octave;
						if (!voiceRange.lowestNote) {
							strVal = 'highest note = ' + strVal;
							if (!voiceRange.highestNote.exactMatch) strVal+= ' or lower';
						}
					}
					*/
					break;

				case 'accompanistDifficulty':
					strVal = val;
					if (val != 1) strVal += ' or easier';
					break;

				case 'originalKey':
					strVal = val.majorMinor;
					if (val.pitch) strVal = val.pitch + ' ' + strVal;
					break;

				case 'tags':
					var tags = val.split(',');
					label = '<em>Tags</em> must match all of the following: ';
					strVal = tags.join(', ');
					break;
					
				case 'popularities':
					if (Array.isArray(val)) {
						strVal = val.map(function(popularityNum) {
							return popularityLabels[popularityNum];
						})
						.join(', ');
					}
					else strVal = popularityLabels[val];
					break;
					
				case 'isRecommended':
					strVal = 'Yes';
					break;

				default:
					if (typeof val == 'string') {
						strVal = val;
					}
					else if (Array.isArray(val)) {
						strVal = val.join(', ');
					}
					else continue;
			}

			searchParamStrs[field] = label + '<dd>' + strVal + '</dd>';
		}

		var arrSearchParamStrs = [];
		for (var field in searchParamStrs) {
			arrSearchParamStrs.push(searchParamStrs[field]);
		}

		model.set('_page.firstFewSearchParams', arrSearchParamStrs.slice(0, 4).join(''));
		model.set('_page.numRemainingSearchParams', arrSearchParamStrs.length <= 4 ? 0: arrSearchParamStrs.length - 4);
		model.set('_page.remainingSearchParams', arrSearchParamStrs.slice(4).join(''));

		if (search.dateSongCreated) {
			model.set('_page.isRecentlyAddedSongsSearch', true);
		}
		if (search.dateShowCreated) {
			model.set('_page.isRecentlyAddedShowsSearch', true);
		}
		
		//"Find contrasting song" is only relevant if comedic/dramatic and/or tempo was one of the search conditions.
		//In the case of tempo, the selected tempo must have been either Easy Ballad or Up-Tempo
		var showFindContrastingSongsButton = ('isComic' in search);
		if (!showFindContrastingSongsButton && ('tempos' in search)) {
			var containsEasyBallad = (search.tempos.indexOf('Easy Ballad') != -1);
			var containsUpTempo = (search.tempos.indexOf('Up-Tempo') != -1);
			if (containsEasyBallad || containsUpTempo) {
				//if both were selected, then there's nothing to reverse to search for contrasting songs
				if (! (containsEasyBallad && containsUpTempo) ) {
					showFindContrastingSongsButton = true;
				}
			}
		}
		model.set('_page.showFindContrastingSongsButton', showFindContrastingSongsButton);
		
		//Firefox localStorage workaround only works on the client
		if (!model.get('_page.isFirefox')) {
			getSongListsForCurrentUserAsync(model, function(songLists) {
				model.set('_page.songListForm.songLists', songLists);
				page.render('search-results');
			});
		}
		else {
			model.set('_page.songListForm.songLists', []);
			page.render('search-results');
		}
	}
}

//Get the base URL, including search or other params but without pagination and sort parameters
function getCurrentPageBaseUrl(url) {
	var pos = url.search(/(\?|&)(page|sort)=/);
    if (pos != -1) {
        url = url.substr(0, pos); '&';
    }
    return url + (url.indexOf('?') == -1 ? '?': '&');
}

//Song detail page
app.get('/song/:id', function(page, model, params, next) {
	var SearchSongsUseCase = require('../use-cases/SearchSongs');
	var searchSongsUseCase = new SearchSongsUseCase(model);
	var popularityLabels = getSongFormOptions().popularityLabels;
	var songId = params.id;

	//TEMP
	//force server rendering for now as a workaround
	//external links are only appearing when page is rendered client-side for the first time, not if you go to another page
	//and then click the Back button
	//
	//ALTHOUGH...we may want to force server rendering anyway since '_session.user.isSubscribed' is writable by the client
	if (!require('derby').util.isServer) {
		window.location = params.url;
		return;
	}

	model.set('_page.isSongDetailPage', true); //needed by songList.createOrUpdate controller method
	//for songs with public domain scores
	model.set('_config.scorePdfDir', '/pdf-scores');

	var songModel = model.at('songs.'+songId);
	model.fetch(songModel, function(err) {
		if (err) return next(err);
		var song = deepCopy(songModel.get());
		if (!song) {
			return next();
		}
		
		song.popularityLabel = popularityLabels[song.popularity] || null;

		if (!model.get('_session.user.isSubscribed')) {
			//Non-subscribers are only allowed to see songs by this month's free featured composers
			var featuredComposerIds = searchSongsUseCase.getFeaturedComposerIds();
			var match = false;
			for (var composerId in songModel.get('composers')) {
				if (featuredComposerIds.indexOf(composerId) != -1) {
					match = true;
					break;
				}
			}
			if (!match) {
				model.ref('_page.song', songModel);
				page.render('errors:subscriber-only-song');
				return;
			}
		}
		
		model.set('_page.song', song);
		/*
	    model.set('_page.song', model.evaluate(
	        'composerAndLyricistNamesSingle', //reactive function (defined in reactive-fns.js)
	        songModel //input path
	    ));
		*/
	    model.set('_page.song.tags', model.get('_page.song.tags').sort());

		//External Links

		var baseSearchUrls = Song.getExternalLinkBaseSearchUrls();

		//get references to some functions we need that are defined as view helpers
		var stripPunctuation = app.view.getFns.stripPunctuation,
			stripSpacesAndPunctuation = app.view.getFns.stripSpacesAndPunctuation;

		var songTitle = songModel.get('title'),
			showTitle = songModel.get('showTitle');
			
		//used below for IMSLP links
		var imslpUrlBase = 'http://imslp.org/',
			imslpUrlBaseLength = imslpUrlBase.length;
		function isImslpUrl(url) {
			return (url.substr(0, imslpUrlBaseLength) === imslpUrlBase);
		}
			
		//TODO it might be possible to do this automatically; see https://github.com/cjblomqvist/derby-refList-wrapper
		//Or we could just store the links collections as arrays rather than hashes in the DB
		//
		//convert externalLinks hashes to arrays and generate URLs for the links marked as automatic
		var externalLinks = songModel.get('externalLinks');
		for (var category in externalLinks) {
			var links = [],
				link,
				url;
			for (var id in externalLinks[category]) {
				link = externalLinks[category][id];
				//only include enabled links
				if (!link.enabled) continue;

				//automatic link
				if (link.automatic) {
					if (link.id == 'iTunes') {
						url = baseSearchUrls.recordings.iTunes + stripSpacesAndPunctuation(showTitle);
					}
					else if (link.id == 'spotify') {
						//This still isn't bringing up results for too many songs...forcing album-only search for now
						/*
						if (link.includeSongTitle) {
							//use Spotify's advanced search feature (https://support.spotify.com/us/learn-more/faq/#!/article/Advanced-search1)
							url = baseSearchUrls.recordings.spotify + 'album%3A' + encodeURIComponent(showTitle) + '%20OR%20title%3A' + encodeURIComponent(songTitle);
						}
						else url = baseSearchUrls.recordings.spotify + '%22' + encodeURIComponent(stripPunctuation(showTitle)) + '%22';
						*/

						url = baseSearchUrls.recordings.spotify + 'album%3A' + encodeURIComponent(showTitle);
						//url = baseSearchUrls.recordings.spotify + '%22' + encodeURIComponent(stripPunctuation(showTitle)) + '%22';
					}
					//special case for Manhattan Marymount
					else if (model.get('_session.user.firstName') == 'Manhattan Marymount' && link.id == 'contemporaryMusicalTheatre') {
						//see note below
						url = 'https://www.contemporarymusicaltheatre.com/';
					}
					else {
						if (!baseSearchUrls[category] || !baseSearchUrls[category][link.id]) {
							console.warn && console.warn("Missing base search URL for '" + category + "', " + link.id + "'");
							continue;
						}
						//include quotes around the show title
						url = baseSearchUrls[category][link.id] + '%22' + encodeURIComponent(stripPunctuation(showTitle)) + '%22';
						if (link.includeSongTitle) url += '%20' + encodeURIComponent(stripPunctuation(songTitle));
					}
				}
				//manual link
				else {
					url = link.url;
					
					//Affiliate links
					switch (link.id) {
						case 'amazon':
							url += '&tag=musicalcom0e-20';
							break;
							
						//special case:
						//for now at least, we point all contemporarymusicaltheatre.com links to their homepage
						//(to avoid interfering with the fact that they require paid subscriptions to search their songs).
						case 'contemporaryMusicalTheatre':
							//special case for Manhattan Marymount
							if (model.get('_session.user.firstName') == 'Manhattan Marymount') {
								url = 'https://www.contemporarymusicaltheatre.com/';
							}
							break;
					}
				}
				if (!url) continue;
				
				var siteName = link.siteName;
				//special cases
				if (isImslpUrl(url)) {
					siteName += ' (public domain database)';
				}
				else if (siteName == 'halhkmusic.com' || siteName == 'Halhkmusic.com') {
					siteName += ' (MIDI/Karaoke Files)';
				}
				
				links.push({
					id: link.id
				  , siteName: siteName
				  , url: url
				});
			}

			externalLinks[category] = links;
		}

		model.set('_page.song.externalLinks', externalLinks);

		var showModel = model.at('shows.'+songModel.get('showId'));
		
		//also get full composer and lyricist objects (so we can include info / Wikipedia links for the composers and lyricists)
		var composerIds = Object.keys(song.composers),
			lyricistIds = Object.keys(song.lyricists);
		var composersQuery = model.query('composers', {id: {$in: composerIds}}),
			lyricistsQuery = model.query('lyricists', {id: {$in: lyricistIds}});
		
		model.fetch(showModel, composersQuery, lyricistsQuery, function(err) {
			if (err) return next(err);
			if (!showModel.get()) return next();

			//TODO Should this do a search using the show ID rather than the show title?
			//Link to all songs in this show
			var search = {showTitle: showModel.get('title')};
			model.set('_page.linkToShow', '/search/songs?search=' + encodeURIComponent(JSON.stringify(search)) + '&sort=showSortTitle,pageNumbers.start');

			//Wikipedia link and public domain score (if applicable) are stored with the show, not the song
			model.ref('_page.show', showModel);
			
			composersQuery.ref('_page.composers');
			lyricistsQuery.ref('_page.lyricists');

			//log(showModel.get())
			
			//Special cases:
			if (model.get('_session.loggedInViaIpRecognition')) {
				switch (model.get('_session.institutionDomainName')) {
					//Catholic University of America
					case 'cua.edu':
						var wrlcTitleSearch = encodeURIComponent(showModel.get('sortTitle'));
						externalLinks.scores.unshift({
							id: 'wrlc',
							siteName: 'CUA Libraries',					
							url: 'http://catalog.wrlc.org/cgi-bin/Pwebrecon.cgi?SAB1=' + wrlcTitleSearch + '&BOOL1=as+a+phrase&FLD1=Title+%28keyword%29+%28TKEY%29&GRP1=AND+with+next+set&SAB2=vocal+score&BOOL2=as+a+phrase&FLD2=Keyword+Anywhere+%28GKEY%29&GRP2=AND+with+next+set&LOCA=-CATHOLIC%20UNIVERSITY|1&CNT=25&HIST=1'
						});
						externalLinks.recordings.unshift({
							id: 'wrlc',
							siteName: 'CUA Libraries',					
							url: 'http://catalog.wrlc.org/cgi-bin/Pwebrecon.cgi?SAB1=' + wrlcTitleSearch + '&BOOL1=as+a+phrase&FLD1=Title+%28keyword%29+%28TKEY%29&GRP1=AND+with+next+set&SAB2=sound+recording&BOOL2=as+a+phrase&FLD2=Keyword+Anywhere+%28GKEY%29&GRP2=AND+with+next+set&LOCA=-CATHOLIC%20UNIVERSITY|1&CNT=25&HIST=1'
						});
						break;
					
					//The University of the Arts (in PA)
					case 'uarts.edu':
						var encodedSongTitle = encodeURIComponent(song.sortTitle);
						externalLinks.scores.unshift({
							id: 'uarts',
							siteName: 'UARTS Library',					
							url: 'http://catalog.library.uarts.edu/search/?searchtype=X&searchscope=6&searcharg="' + encodedSongTitle + '"'
						});
						externalLinks.recordings.unshift({
							id: 'uarts',
							siteName: 'UARTS Library',					
							url: 'http://catalog.library.uarts.edu/search/?searchtype=X&searchscope=6&searcharg="' + encodedSongTitle + '"'
						});
						break;
				}
			}			
			
			//TODO we don't need to do this here; we could just do it if the user clicks the Add to Song List button
			//retrieve the user's song lists so we can populate the dropdown of existing song lists
			//if the user clicks the "Add to Song List" button
			getSongListsForCurrentUserAsync(model, function(songLists) {
				model.set('_page.songListForm.songLists', songLists);
				
				var hasAddCommentsPermission = model.get('_session.user.isSubscribed') && model.get('_session.loggedIn');
				model.set('_page.hasAddCommentsPermission', hasAddCommentsPermission);
				if (hasAddCommentsPermission) {
					//for subscribers, check if they've added any comments about this song
					if (model.get('_session.user.isSubscribed')) {
						var userId = model.get('_session.userId');
						var commentsQuery = model.query('songComments', {
							userId: userId
						  , songId: songId
						});
						model.fetch(commentsQuery, function(err) {
							if (err) {
								log("Error retrieving user's song comments");
								return;
							}
							var comments = commentsQuery.get();
							if (comments.length) {
								//The system is currently set up for only one comment entry per user per song
								if (comments.length > 1) {
									log('Error: multiple comment entries for the same song for user ID '+userId+' and song ID '+songId);
								}
								else {
									model.set('_page.commentEntry', comments[0]);
								}
							}
							page.render('song-detail');
						});
					}
					else page.render('song-detail');
				}
				else page.render('song-detail');
			});
		});
	});
});

app.get("/login", function(page, model, params, next) {
  //force server-side rendering so that we can redirect to https:// if needed
  if (!require('derby').util.isServer) {
		window.location = params.url;
		return;
  }

  if (model.get('_session.loggedIn')) return page.redirect('/account');

  model.set('_page.requestedUrl', params.query.requestedUrl);
  var user = model.at("auths." + (model.get("_session.userId")));
  //note that subscribe() is a standard Derby model method; we are *not* creating a subscription for the user here
  return user.subscribe(function(err) {
    if (err) return next(err);
    model.ref("_page.user", user);
    return page.render('login');
    //return page.render('auth');
  });
});

app.get("/logintest", function(page, model, params, next) {
	//model.set("_session.loggedIn", null, function() {
		  var user = model.at("auths." + (model.get("_session.userId")));
		  return user.subscribe(function(err) {
		    if (err) return next(err);
		    model.ref("_page.user", user);
		    return page.render('logintest');
		  });
	//});
});

app.get('/subscribe', function(page, model, params, next) {
	model.set('_page.featuredSubscriberList', [
		'Anderson University',
		'Belmont University',
		'Berklee College of Music',
		'Birmingham Southern College',
		'Boston Conservatory',
		'Bowling Green State University',
		'Brevard College',
		'California State University-Chico',
		'Catholic University',
		'Charles County Public Schools',
		'Chicago High School For The Arts',
		'Clarke University',
		'College of William And Mary',
		'Community College of Rhode Island',
		'Converse College',
		'Coastal Carolina University',
		'Depauw University',
		'Elon University',
		'Hardin-Simmons University',
		'Harvard University',
		'Hofstra University',
		'Houston High School Of The Performing Arts',
		'Illinois Wesleyan University',
		'Indiana University of Pennsylvania',
		'John Brown University',
		'Loyola-New Orleans',
		'Manhattanville College',
		'McCallum Fine Arts Academy',
		'Michigan State University-Lansing',
		'Missouri State University',
		'New England Conservatory of Music',
		'Notre Dame Du Namur University',
		'Ouachita Baptist University',
		'Pace University',
		'Rider University',
		'Seattle Pacific University',
		'South Eastern Missouri State University',
		'Shawnee State University',
		'Shenandoah University',
		'Southwest College',
		'St. Lawrence College',
		'Texas State University',
		'University of Alabama',
		'University of Cincinnati ',
		'University of Kansas',
		'University of Michigan',
		'University of Michigan-Flint',
		'University of Nevada-Reno',
		'University of North Carolina-Chapel Hill',
		'University of Portland',
		'University of The Arts',
		'University of Washington',
		'University of Wisconsin-Stevens Point',
		'University of Wyoming',
		'Washington And Lee University',
		'Western Wyoming Community College',
		'Yale University'
	]);

	//model.set('_page.hideSubscribeSidebar', true);
	page.render('account:subscribe');
	//page.render('subscribe');
});

app.get('/subscribe-form', subscribeForm);
app.get('/subscribe-form/:subscriptionType', subscribeForm);
function subscribeForm(page, model, params, next) {
	if (!require('derby').util.isServer && window.location.protocol != 'https:') {
		//require SSL (server will take care of redirect)
		window.location = params.url;
		return;
	}

	//If a user who already created an account (even if they didn't pay for a subscription yet)
	//reaches this page for whatever reason, redirect them to the billing page
	if (model.get('_session.loggedIn') && !model.get('_session.loggedInViaIpRecognition')) {
		//if (model.get('_config.ENVIRONMENT') != 'local')
		return page.redirect('/subscribe/payment');
	}

	model.set('_session.subscriptionType', params.subscriptionType);

    model.set('_page.hideSidebar', true);
    model.set('_page.hideSubscribeBanner', true);
    page.render('account:subscribe-form');
}

app.get('/subscribe/payment', subscriptionPaymentPage);
app.get('/account/renew-subscription', function(page, model, params, next) {
	subscriptionPaymentPage(page, model, params, next, true);
});

function subscriptionPaymentPage(page, model, params, next, isRenewal) {
	if (! require('derby').util.isServer) {
		//force server-side rendering so that we can use Stripe API
		//to look up the credit card on file
		window.location = params.url;
		return;
	}

	//Account creation happens before this form, so the user should already be logged in
	if (!model.get('_session.userId')) return page.redirect('/login?requestedUrl=' + encodeURIComponent(params.url));
	
	var userId = model.get('_session.userId');
	
	checkForExistingSubscriptions(function() {
		if (isRenewal) {
			var userModel = model.at('auths.' + userId);
			//get the most recent subscription for this user
			var subscriptionQuery = model.query('subscriptions', {
				userIds: {$in: [userId]}
			  , $orderby: {startDate:-1}
			});
			model.fetch(userModel, subscriptionQuery, function(err) {
				if (err) return next(err);
	
				var subscriptions = subscriptionQuery.get();
				if (!subscriptions.length) {
					return page.redirect('/account');
				}
	
				var sub = Subscription.fromJSON(subscriptions[0]);
				model.set('_page.planId', sub.planId);
				model.set('_page.automaticRenewal', !!sub.automaticRenewal);
				//we don't yet support changing the subscription type from individual to group (or vice versa) on this form
				model.set('_page.showIndividualPlans', !sub.isGroupSubscription);
				model.set('_page.showGroupPlans', sub.isGroupSubscription);
				
				if (sub.stripeCharge && sub.stripeCharge.metadata.couponCode == 'FRIEND') {
					model.set('_page.extendedFriendDiscount', true);
				}
	
				var hasCardOnFile = sub.hasCardOnFile();
				model.set('_page.rememberCardInfo', hasCardOnFile);
				if (hasCardOnFile) {
					model.set('_page.useCardOnFile', true);
					//get card info so we can display last 4 digits and expiration
					getDefaultStripeCardAsync(userModel.get('stripeId'), function(err, card) {
						//log('card', card)
						model.set('_page.card', card);
					});
				}
			});
	
			model.set('_page.purchaseButtonLabel', 'Renew Subscription');
		}
		else {
			if (model.get('_config.ENVIRONMENT') != 'local') { //for ease of testing
				//if the user already has a subscription, there shouldn't be any link available to this page,
				//but just in case, redirect them to the "My Subscription" page
				if (model.get('_session.user.isSubscribed')) return page.redirect('/account/subscription');
			}
		
			model.set('_page.showIndividualPlans', true);
			model.set('_page.showGroupPlans', true);
			model.set('_page.purchaseButtonLabel', 'Purchase Subscription');
	
			//Check if plan ID was specified in the URL
			var planId = params.query.planId;
			
			//For institutional subscriptions, subscriptionPlanId is set to the session on the first page of the signup process
			if (!planId) planId = model.get('_session.subscriptionPlanId');
			if (planId) {
				model.set('_page.planId', planId);
				if (params.query.numUsers)
					model.set('_page.numUsers', params.query.numUsers);
			}
			else {
				//default to automatic renewal
				model.set('_page.automaticRenewal', true);
				model.set('_page.rememberCardInfo', true);
			}
			
			model.set('_page.howDidYouHearOptions', ['Friend', 'Colleague', 'Teacher/Professor', 'Internet Search', 'Website', 'Facebook', 'Other']);
		}
	
		model.set('_page.hideSidebar', true);
		model.set('_page.hideSubscribeBanner', true);
	
		//get current user
		var userModel = model.at('auths.' + model.get('_session.userId'));
		//get list of countries
		var qCountries = model.query('countries', {$orderby: {name:1}});
	
		model.fetch(userModel, qCountries, function(err) {
			if (err) return next(err);
	
			qCountries.ref('_page.countries');
	
			//default to US
			if (!userModel.get('address.countryCode')) {
				userModel.set('address.countryCode', 'US');
			}
	
			model.set('_page.user', userModel.get());
			
			if (planId) model.set('_page.specialPricing', true);
	
			if (isRenewal) {
				page.render('account:renew-subscription');
			}
			else page.render('account:subscribe-billing');
		});
	});
	
	function checkForExistingSubscriptions(cb) {
		//if we're already on the renewal form, no need for the below check.
		if (isRenewal) {
			cb();
			return;
		}
	
		var subsQuery = model.query('subscriptions', {purchaserUserId: {$in: [userId]}});
		subsQuery.fetch(function(err) {
			if (err) return console.error(err);
			
			//If the user was previously subscribed, they should renew via the renewal form, not here.
			//Redirect to My Account where they can click Renew if they want.
			if (subsQuery.get().length > 0) {
				if (model.get('_config.ENVIRONMENT') != 'local') { //for ease of testing
					return page.redirect('/account/subscription');
				}
			}
			
			cb();
		});
	}
}

//TEMP copied from server/routes.js
//Get a customer's default card
function getDefaultStripeCardAsync(stripeId, cb) {
	var stripe = require('stripe')(process.env.STRIPE_SECRET);

	//Get the Stripe card object (contains the last 4 digits and expiration of the customer's card)
	stripe.customers.retrieve(stripeId, function(err, customer) {
		if (err) return cb(err);
		var defaultCardId = customer.default_card;
		var stripeCard;
		customer.cards.data.forEach(function(card) {
			if (card.id == defaultCardId) {
				cb(null, card);
				return false;
			}
		});
	});
}

//
//
//*****************************************************************
//TODO delete this once all links are changed to /subscribe/payment
//
app.get('/subscribe-billing', function(page, model, params, next) {
	
	
	//THIS FUNCTION WILL BE DELETED ONCE ALL LINKS ARE CHANGED TO /subscribe/payment

	if (model.get('_config.ENVIRONMENT') != 'local') { //for ease of testing
		//if the user already has a subscription, there shouldn't be any link available to this page,
		//but just in case, redirect them to the "My Subscription" page
		if (model.get('_session.user.isSubscribed')) return page.redirect('/account/subscription');
	}

	if (! require('derby').util.isServer) {
		//TEMP
		//force server-side rendering until we figure out how to properly include the
		//https://js.stripe.com/v2/  script on both client and server without loading it
		//on every page
		window.location = params.url;
		return;
	}

	//Account creation happens before this form, so the user should already be logged in
	if (!model.get('_session.userId')) return page.redirect('/login');

	model.set('_page.purchaseButtonLabel', 'Purchase Subscription');
	model.set('_page.hideSidebar', true);
	model.set('_page.hideSubscribeBanner', true);

	//get current user
	var userId = model.get('_session.userId');
	var userModel = model.at('auths.' + userId);
	
	//get list of countries
	var qCountries = model.query('countries', {$orderby: {name:1}});

	model.fetch(userModel, qCountries, function(err) {
		if (err) return next(err);
		
		checkForExistingSubscriptions(function() {		
			qCountries.ref('_page.countries');

			//default to US
			if (!userModel.get('address.countryCode')) {
				userModel.set('address.countryCode', 'US');
			}

			model.set('_page.user', userModel.get());
		
			page.render('account:subscribe-billing');
		});
	});
	
	function checkForExistingSubscriptions(cb) {
		var subsQuery = model.query('subscriptions', {purchaserUserId: {$in: [userId]}});
		subsQuery.fetch(function(err) {
			if (err) return console.error(err);
		
			//If the user was previously subscribed, they should renew via the renewal form, not here.
			//Redirect to My Account where they can click Renew if they want.
			if (subsQuery.get().length > 0) {
				if (model.get('_config.ENVIRONMENT') != 'local') { //for ease of testing
					return page.redirect('/account/subscription');
				}
			}
			
			cb();
		});
	}
});

app.get('/song-lists', function(page, model, params, next) {
	//require server rendering for this page since the session info in the model
	//might not be up-to-date
	if (!require('derby').util.isServer) return next();
	
	//Workaround for Firefox - load song lists from cookie instead
	//(issue with sessions over HTTPS)
	if (page._res.req.headers['user-agent'].indexOf('Firefox') != -1) {
		model.set('_page.isFirefox', true);
	}
	
	getSongListsForCurrentUserAsync(model, function(songLists) {
		for (var i=0; i < songLists.length; i++) {
			list = songLists[i];
			if (list._prototype=='StaticSongList') {
				//show number of songs in list
				list.details = list.songIds.length + ' song' + (list.songIds.length==1 ? '': 's');
			}
			else {
				list.details = 'auto-updating list; click to see songs';
			}
		}
		
		model.set('_page.songLists', songLists);
		var isLimitedAccount = (model.get('_session.institutionalPlanType') == 'singleLimitedAccount');
		model.set('_page.isLimitedInstitutionalAccount', isLimitedAccount);
		//For non-subscribers and singleLimitedAccount institutional accounts, get the song list from the session
		model.set('_page.songListsStoredInSession', !model.get('_session.user.isSubscribed') || isLimitedAccount);
		
		//temp solution until sharing links are implemented for regular subscribers too...
		//model.set('_page.showSaveShareLink', isLimitedAccount);
		
		page.render('song-lists');
	});
});

/**
 * @return {array}
 */
function getSongListsForCurrentUserAsync(model, callback) {
	var userIsSubscriber = model.get('_session.user.isSubscribed');
	
	//Free users don't have accounts, so we retrieve the song lists from the session that were made
	//available by server/index.js.
	//We also retrieve the song lists from the session for singleLimitedAccount institutional accounts
	if (!userIsSubscriber || model.get('_session.institutionalPlanType') == 'singleLimitedAccount') {
		//convert the songList map to an array so view bindings will work
		var songLists = model.get('_session.songLists'),
			arrSongLists = [],
            list;

		for (var songId in songLists) {
			list = songLists[songId];
			//use the name as the ID since there's no real songList ID for the free version
			list.id = list.name;
			arrSongLists.push(list);
		}

		arrSongLists = sortByKey(arrSongLists, 'name');
		callback(arrSongLists);
	}
	else {
		//For subscribers, get the song lists from the DB
		var query = model.query('songLists', {userId: model.get('_session.userId')});
		model.fetch(query, function(err) {
			if (err) {
				log('Error retrieving song lists:')
				console.error(err);
				return;
			}
			var songLists = sortByKey(query.get(), 'name');

			callback(songLists);
		});
	}
}

//case-insensitive sort
function sortByKey(arr, key) {
	//type checks are important to prevent the server from crashing in the event of wrong arguments passed
	if (!Array.isArray(arr)) {
		console.error('sortByKey(): first argument must be array');
		return arr;
	}
	if (typeof key != 'string') {
		console.error('sortByKey(): key must be string')
		return arr;
	}
	return arr.sort(function(a, b) {
		a = getSortName(a[key]);
		b = getSortName(b[key]);
		if( a == b) return 0;
		if( a > b) return 1;
		return -1;
	});
}

//Converts to lower case and strips punctuation
//so sorting will work properly
function getSortName(name) {
	return name.toLowerCase().replace(/[^\w\s]/g, '');
}


//View individual song list
app.get('/song-lists/:id', viewSongList);
app.get('/song-lists/session/:id', function(page, model, params, next) {
	viewSongList(page, model, params, next, true);
});

function viewSongList(page, model, params, next, getFromSession) {
	//We always render this route on the server so that edit codes are validated on the server
	//and never on the client (edit codes are used for editing shared lists).
	//Of course there's still the issue of the editCode property in songList objects...see below.
	if (!require('derby').util.isServer) return next();
	
	var SongList = require('../data-objects/SongList');
	
	//Workaround for Firefox - load song lists from cookie instead
	//(issue with sessions over HTTPS)
	if (page._res.req.headers['user-agent'] && page._res.req.headers['user-agent'].indexOf('Firefox') != -1) {
		model.set('_page.isFirefox', true);
	}
	var session = page._res.req.session;

	model.set('_page.songListStoredInSession', !!getFromSession);
	
	var editCode = params.query.editCode;
	model.set('_page.editCode', editCode);
	
	//TODO What if it's a static song list and the composers of the month have changed?

	var list;
	//For non-subscribers and singleLimitedAccount institutional accounts, get the song list from the session
	if (getFromSession) {
	//if (!model.get('_session.user.isSubscribed') || model.get('_session.institutionalPlanType') == 'singleLimitedAccount') {
		//retrieve song list from session variable
		var listJson = model.get('_session.songLists.' + params.id);
		if (!listJson) {
			return page.redirect('/song-lists');
		}
		
		//restore SongList object
		list = SongList.fromJson(listJson);
		
		model.set('_page.hasEditPermission', true);
		model.set('_page.hasCommentingPermission', false);
		renderSongListDetailPage(list, page, model, params, next);
	}
	//For subscribers, get the song list from the DB
	else {
		var songListModel = model.at('songLists.' + params.id);
		songListModel.subscribe(function(err) {
			if (err) return next(err);
			var listJson = songListModel.get();
			if (!listJson) {
				return page.redirect('/song-lists');
			}

			//restore SongList object
            list = SongList.fromJson(listJson);
			
			//does the user have permission to edit the list?
			var hasEditPermission = userHasPermissionToEditList(model, session, list, editCode);
			model.set('_page.hasEditPermission', hasEditPermission);
			model.set('_page.hasCommentingPermission', hasEditPermission && model.get('_session.loggedIn'));
			
            renderSongListDetailPage(list, page, model, params, next);
		});
	}
}

function userHasPermissionToEditList(model, session, list, editCode) {
	//TODO
	//security fix:
	//list.editCode is currently accessible on the client.
	//Derby queries and model.fetch() calls are able to retrieve song list objects including the editCode property.

	var userId = model.get('_session.userId');
	//is the user editing their own list?
	if (userId && list.userId && userId === list.userId
		&& model.get('_session.institutionalPlanType') != 'singleLimitedAccount'
	) {
		return true;
	}
	if (editCode && list.editCode == parseInt(editCode)) {
		//This allows us to do a security check when saving changes to a list that was shared with the current user.
		//We store it in the session so that as soon as you open a shared list with a valid edit code, the system
		//remembers that you have edit permission. This is important because adding additional songs to the list
		//could be done at any point during the session.
		//See save-song-list server-side route.
		if (!session.songListIdsWithEditPermission) session.songListIdsWithEditPermission = {};
		session.songListIdsWithEditPermission[list.id] = true;
	
		return true;
	}
	return false;
}

function renderSongListDetailPage(list, page, model, params, next) {
	var StaticSongList = require('../data-objects/SongList/StaticSongList');
	
	model.set('_page.origSongList', deepCopy(list));
	
	//get songs from DB
	var query = list.getSongsQueryParams();
	
	//check for empty list
	if (!query) {
		model.set('_page.songList', list);
		page.render('song-lists:view');
		return;
	}
	query = new MongoQuery(query);
	if (params.query.sort) query.setSortOrder(params.query.sort);
	
	list.isStaticList = (list instanceof StaticSongList);

	var isLimitedAccount = (model.get('_session.institutionalPlanType') == 'singleLimitedAccount');
	//model.set('_page.showSaveShareLink', isLimitedAccount);
	
	//log('song list query', query)
	
	//Get paginated query
	var paginator = new Paginator(model, 'songs', params, query, '_page.paginator');
	model.set('_page.currentBaseUrl', getCurrentPageBaseUrl(params.url));

	var songQuery = paginator.getQueryForCurrentPage();

	model.subscribe(songQuery, function(err) {
		if (err) return next(err);
		//log('# songs', songQuery.get().length)

		songQuery.ref('_page.songsRaw'); //raw data from DB
        list.songs = model.evaluate(
            'composerAndLyricistNames', //reactive function (defined in reactive-fns.js)
            '_page.songsRaw' //input path
        );

        //Get any comments the user entered for these songs
        var songsById = {};
        songQuery.get().forEach(function(song) {
            songsById[song.id] = song;
        });
        var commentsQuery = model.query('songComments', {
            userId: model.get('_session.userId')
          , songId: {$in: Object.keys(songsById)}
        });
        model.fetch(commentsQuery, function(err) {
        	if (err) return next(err);
			var comments = commentsQuery.get();
			var commentsBySongId = {};
			comments.forEach(function(item) {
				commentsBySongId[item.songId] = item;
//				songsById[item.songId].userCommentsId = item.id;
//				songsById[item.songId].userComments = item.comments;
			});

			
			model.set('_page.songList', list);
			model.set('_page.commentsBySongId', commentsBySongId);
			page.render('song-lists:view');
        });
	});
}

//Update billing info
//Note: /account and /account/subscribe are server-only routes
app.get('/account/billing', function(page, model, params, next) {
	if (! require('derby').util.isServer) {
		//TEMP
		//force server-side rendering until we figure out how to properly include the
		//https://js.stripe.com/v2/  script on both client and server without loading it
		//on every page
		window.location = params.url;
	}
	if (!model.get('_session.userId')) return page.redirect('/login');

	model.set('_page.hideSidebar', true);
	model.set('_page.hideSubscribeBanner', true);

	var userId = model.get('_session.userId');
	//get current user
	var userModel = model.at('auths.' + userId);
	//get list of countries
	var qCountries = model.query('countries', {$orderby: {name:1}});

	//get the most recent subscription for this user
    var subscriptionQuery = model.query('subscriptions', {
        userIds: {$in: [userId]}
      , $orderby: {startDate:-1}
    });

	model.fetch(userModel, qCountries, subscriptionQuery, function(err) {
		if (err) return next(err);

		qCountries.ref('_page.countries');

		//default to US
		if (!userModel.get('address.countryCode')) {
			userModel.set('address.countryCode', 'US');
		}

		var subscriptions = subscriptionQuery.get();
		if (!subscriptions.length) {
			return page.redirect('/account/subscription');
		}

		model.set('_page.user', userModel.get());
		model.set('_page.subscription', subscriptions[0]);

		page.render('account:billing');
	});
});

app.get('/account/cancel-subscription-confirm', function(page, model, params, next) {
	page.render('account:cancel-subscription-confirm');
});

app.get('/about', function(page, model, params, next) {
	page.render('about');
});

// Added by Eric on Sep 30, 2021

app.get("/resources", resources)
function resources(page, model, params, next) {
  model.set("_page.hideSidebar", true);
  model.set("_page.isResourcesPage", true);

  var resourceQuery = model.query("resources", { $orderby: { title: 1 } });
  resourceQuery.subscribe(function (err) {
    if (err) return next(err);

    //do a case-insensitive sort
    model.set("_page.resources", sortByKey(resourceQuery.get(), "title"));

    page.render("resources");
  });
}

// End addition

app.get('/help', glossary); //maybe default to FAQ once there are more questions there
app.get('/help/faq', faq);
function faq(page, model, params, next) {
	model.set('_page.hideSidebar', true);
	model.set('_page.isFaqPage', true);
	
	var faqQuery = model.query('faq', {$orderby: {sortNum:1}});
	faqQuery.subscribe(function(err) {
		if (err) return next(err);

		model.set('_page.faq', faqQuery.get());
		//we don't want to do this because the controller sets the .showAnswer property
		//when a question is clicked, and we don't want that to get stored in the DB
		//faqQuery.ref('_page.faq');

		page.render('help:faq');
	});
}

app.get('/help/glossary', glossary);
function glossary(page, model, params, next) {
	model.set('_page.hideSidebar', true);
	model.set('_page.isGlossaryPage', true);

	var glossaryQuery = model.query('glossary', {$orderby: {term:1}});
	glossaryQuery.subscribe(function(err) {
		if (err) return next(err);
		//glossaryQuery.ref('_page.terms');

		//do a case-insensitive sort
		model.set('_page.terms', sortByKey(glossaryQuery.get(), 'term'));

		page.render('help:glossary');
	});
}

app.get('/contact', function(page, model, params, next) {
	page.render('contact');
});

app.get('/privacy', function(page, model, params, next) {
	page.render('privacy');
});

app.get('/terms-conditions', function(page, model, params, next) {
	page.render('terms-conditions');
});

//TEMPORARY PAGE - RESOLVING MISSING DATA ISSUE
app.get('/missing-data', function(page, model, params, next) {
	params.field = 'ageRanges';
	return missingData(page, model, params, next);
});
app.get('/missing-data/:field', missingData);

function missingData(page, model, params, next) {
	var title;
	switch (params.field) {
		case 'voiceType':
			title = 'Missing voice type'
			break;
		case 'ageRanges':
			title = 'Missing age range'
			break;
		case 'wikipediaUrl':
			title = 'Missing info / Wikipedia link'
			break;
		default:
			title = 'Missing '+params.field;
	}
	model.set('_page.title', title);

	var sortOrder = {showTitle:1, 'pageNumbers.start':1};
	var query = {};

	switch (params.field) {
		case 'tags':
			query.tags = [];
			break;
		default:
			query[params.field] = null;
			//query[params.field] = {$exists:0};
	}
	query.$orderby = sortOrder;
	
	var songQuery = model.query('songs', query);

	model.fetch(songQuery, function(err) {
		if (err) return next(err);

		songQuery.ref('_page.songsRaw'); //raw data from DB
		model.start(
			'composerAndLyricistNames', //reactive function (defined in reactive-fns.js)
			'_page.songs', //output path
			'_page.songsRaw' //input path
		);

		console.log('NUM RESULTS: '+model.get('_page.songsRaw.length'))

		//model.set('_page.songs.length', 'foo')

		page.render('missing-data');
	});
}

//TEMP Access Control test
app.get('/access-test', function(page, model, params, next) {
	var q = model.query('songs', {'voiceType': 'Soprano'});
	model.fetch(q, function(err) {
		if (err) {
			log('returning next(err) in route');
			return next(err);
		}

		var songs = q.get();

		var song = songs[0];

		log('updating song ' + song.id)

		model.set('songs.' + song.id + '.title', 'new test3');

		page.render('temp');
	})

	/*
	var id = "072c4e29-35c1-4258-9cd8-abc0f71fd41a";
	var s = model.at('songs.'+id);
	s.fetch(function(err) {
		if (err) {
			console.log('ERROR!'); return;
		}
		model.set('songs.'+id+'.title', 'my test');
	})
	*/
})

app.get('/access-test2', function(page, model, params, next) {
	var id = "3211268c-9ecd-4a41-9d93-1c5aca41ad8c";
	var userModel = model.at('auths.' + id)
	userModel.fetch(function() {
    	userModel.set('foo', 'bar');
        log('DONE')

        page.render('temp');
    })

//	var id = 'ad057f7f-bd01-4287-88c6-11221edf2ecc'
//	var songModel = model.at('songs.'+id);
//	songModel.fetch(function() {
//		songModel.set('title', 'test');
//
//		log('DONE')
//
//		page.render('temp');
//	})
});

app.get('/creators', function(page, model, params, next) {
	page.render('creators');
});

app.get('/subscribe/generic-payment/:paymentAmount', function(page, model, params, next) {
	if (!params.paymentAmount) {
		return next(Error("Missing payment amount"));
	}
	model.set('_page.stripePaymentAmount', params.paymentAmount * 100);
	page.render('subscribe:generic-payment');
});

app.get('/subscribe/generic-payment-thankyou', function(page, model, params, next) {
	page.render('subscribe:generic-payment-thankyou');
});

app.get('/temp', function(page, model, params, next) {
	page.render('temp');
});

app.get('/temp-update2', function(page, model, params, next) {
	//var model = DERBY.app.model;

	var q = model.query('songs', {"title":{"$exists":1}, "externalLinks.scores":null});
	model.fetch(q, function() {
		var songs = q.get();
		songs.forEach(function(song) {
			log('song ID ' + song.id);

			var externalLinks = {};
			var externalLinksInModel = song.externalLinks;

			//TEMP
//			externalLinksInModel.forEach(function(categoryLinkColl) {
//				var category = categoryLinkColl.category;
//				externalLinks[category] = {};
//				categoryLinkColl.links.forEach(function(link) {
//					externalLinks[category][link.id] = link;
//				});
//			});

		    for (var i in externalLinksInModel) {
		        var categoryLinkColl = externalLinksInModel[i];
				var category = categoryLinkColl.category;
				externalLinks[category] = {};
				categoryLinkColl.links.forEach(function(link) {
					externalLinks[category][link.id] = link;
				});
			}

			model.set('songs.' + song.id + '.externalLinks', externalLinks);
		})
	})
})
